import { _js } from '@ifixit/localize';
import { space } from '@core-ds/primitives';
import { Text } from '@chakra-ui/react';
import { useEditorContext } from '../editor_context';

export const CharacterCount = () => {
   const { editor } = useEditorContext();

   if (!editor) {
      return null;
   }

   const { minCharacters, maxCharacters } = editor.storage.characterCount;

   const charCount = editor.storage.characterCount.characters();
   const tooShort = charCount < minCharacters;
   const tooLong = charCount > maxCharacters;
   const charsLeft = maxCharacters - charCount;

   let charCountText = String(charsLeft);

   // Margin moves this to the bottom left corner of the editor div
   let styleProps: object = {
      color: 'gray.400',
      margin: `-24px 0 0 ${space[2]}`,
      position: 'absolute',
      zIndex: '2',
   };

   if (tooShort) {
      /* Translators: %1 -> number of characters; */
      charCountText = _js('%1 too short', String(minCharacters - charCount));
   } else if (tooLong) {
      /* Translators: %1 -> number of characters; */
      charCountText = _js('%1 too long', String(Math.abs(charsLeft)));
   }

   if (tooLong || tooShort) {
      styleProps = { ...styleProps, fontWeight: 'bold', color: 'red.600' };
   }

   return <Text {...styleProps}>{charCountText}</Text>;
};
